import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[viewMode]',
})
export class ViewModeDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
